import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, Grid, Paper, Typography, Popover, IconButton, FormControlLabel } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { headingBlue, lightGrey, mediumGrey, red } from '../../../assets/colors';
import { buttonStyle, errorTextStyle } from '../../../utils/commonCSS';
import CustomTextField from '../../CustomTextField';
import CustomDatePicker from '../../CustomDatePicker';
import CustomDropDown from '../../CustomDropDown';
import dayjs from 'dayjs';
import _ from 'lodash';
import HttpService from '../../../backend/requestApis';
import { fetchProgramWorkers, fetchTrainingProgramsList, fetchWORKerByCateogary, createTrainingBatch, getStatesList, getDistrictsList } from '../../../backend/backendApis';
import { useNavigate } from 'react-router-dom';
import Loader from '../../Loader';
import { WORKerTypesList } from '../../../utils/constants';
import MultiSelectDropDown from '../../CustomComponents/MultiSelectDropDown';
import AssessmentConfiguration from './AssessmentConfiguration';

const AddBatchDialog = (props) => {
  const navigate = useNavigate();
  const [batchName, setBatchName] = useState('');
  const [batchNameError, setBatchNameError] = useState('');
  const [programsList, setProgramsList] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState('Select Program *');
  const [selectedProgramId, setSelectedProgramId] = useState('');
  const [selectedProgramError, setSelectedProgramError] = useState('');
  const [selectedProgramApplicableFor, setSelectedProgramApplicableFor] = useState([]);
  const [coordinatorList, setCoordinatorList] = useState([]);
  const [selectedCoordinator, setSelectedCoordinator] = useState('Select Coordinator *');
  const [selectedCoordinatorContact, setSelectedCoordinatorContact] = useState('');
  const [coordinatorError, setCoordinatorError] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [startDateError, setStartDateError] = useState('');
  const [endDate, setEndDate] = useState(null);
  const [endDateError, setEndDateError] = useState('');
  const [selectedDays, setSelectedDays] = useState([]);
  const [daysError, setDaysError] = useState('');
  const [isLoader, setLoader] = useState(false);
  const [step, setStep] = useState(1);
  const [availableItems, setAvailableItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [activeLeftItems, setActiveLeftItems] = useState([]);
  const [activeRightItems, setActiveRightItems] = useState([]);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [selectedGender, setSelectedGender] = useState('All');
  const [statesList, setStatesList] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [districtsList, setDistrictsList] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [availableSearch, setAvailableSearch] = useState('');
  


  const selectedItemsRef = useRef([]);
  useEffect(() => {
    selectedItemsRef.current = selectedItems;
  }, [selectedItems]);

  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  var titleStyle = {
    backgroundColor: headingBlue, 
    color: 'white',
    fontSize: '1rem',
    display: "flex",
    alignItems: 'center',
    padding: "0.4rem 0rem 0.4rem 1rem" 
  };

  useEffect(() => {
    setBatchName('');
    setBatchNameError('');
    setStartDate(null);
    setStartDateError('');
    setEndDate(null);
    setEndDateError('');
    setSelectedProgram('Select Program *');
    setSelectedProgramId('');
    setSelectedProgramError('');
    setSelectedProgramApplicableFor([]);
    setCoordinatorList([]);
    setSelectedCoordinator('Select Coordinator *');
    setSelectedCoordinatorContact('');
    setCoordinatorError('');
    setSelectedDays([]);
    setDaysError('');
    setStep(1);
    setAvailableItems([]);
    setSelectedItems([]);
    setActiveLeftItems([]);
    setActiveRightItems([]);
    setFilterAnchorEl(null);
    setSelectedGender('All');
    setStatesList([]);
    setSelectedStates([]);
    setDistrictsList([]);
    setSelectedDistricts([]);
    setAvailableSearch('');
  }, [props.dialogStatus]);

  useEffect(() => {
    if (props.dialogStatus) {
      setLoader(true);
      let options = {
        url: fetchTrainingProgramsList,
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      };
      HttpService(options)
        .then((resp) => {
          let fetchedPrograms = resp?.data?.data || [];
          let formattedList = fetchedPrograms.map(program => ({
            name: program.uniqueId ? `${program.uniqueId} - ${program.programName}` : program.programName,
            value: program._id,
            applicableFor: program.programApplicableFor
          }));
          setProgramsList(formattedList);
          setLoader(false);
        })
        .catch((err) => {
          if (err?.status === 403) {
            localStorage.clear();
            setLoader(false);
            navigate('/Login');
          } else {
            console.log('Error fetching training programs: ', err);
            setLoader(false);
          }
        });
    }
  }, [props.dialogStatus]);

  const fetchCoordinators = (programId) => {
    setLoader(true);
    let options = {
      url: fetchProgramWorkers,
      method: 'GET',
      params: { programId: programId },
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
      }
    };
    HttpService(options)
      .then((resp) => {
        let fetchedWorkers = resp?.data?.data || [];
        let formattedList = fetchedWorkers.map(worker => ({
          name: `${worker.name} - ${worker.contactNumber}`,
          value: worker.contactNumber
        }));
        setCoordinatorList(formattedList);
        setLoader(false);
      })
      .catch((err) => {
        if (err?.status === 403) {
          localStorage.clear();
          setLoader(false);
          navigate('/Login');
        } else {
          console.log('Error fetching coordinators: ', err);
          setLoader(false);
        }
      });
  };

  const fetchAvailableWorkers = (searchValue = '', workerTypes = selectedProgramApplicableFor) => {
    setLoader(true);
    let options = {
      url: fetchWORKerByCateogary,
      method: 'GET',
      params: {
        workerTypes: workerTypes,
        search: searchValue
      },
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
      }
    };
    HttpService(options)
      .then((resp) => {
        let fetchedItems = resp?.data?.data || [];
        let formattedList = fetchedItems.map(worker => ({
            ...worker,
            id: worker._id || worker.contactNumber
        }));
        let filteredList = formattedList.filter(
            (item) => !selectedItemsRef.current.some((sItem) => sItem.id === item.id)
        );
        setAvailableItems(filteredList);
        setLoader(false);
      })
      .catch((err) => {
        if (err?.status === 403) {
          localStorage.clear();
          setLoader(false);
          navigate('/Login');
        } else {
          console.log('Error fetching available workers: ', err);
          setLoader(false);
        }
      });
  };

  const debouncedApiCall = useCallback(
    _.debounce((searchValue, workerTypes) => {
      fetchAvailableWorkers(searchValue, workerTypes);
    }, 500), []
  );

  const updateSearch = (searchValue) => {
    setAvailableSearch(searchValue);
    debouncedApiCall(searchValue, selectedProgramApplicableFor);
  };

  useEffect(() => {
    if (props.dialogStatus) {
      HttpService({
        url: getStatesList,
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      }).then(resp => {
        let states = resp?.data?.data || [];
        // Safely map the response based on whether the API returns strings or objects
        setStatesList(states.map(s => ({ name: s.state || s.name || s })));
      }).catch(err => {
        console.error("Error fetching states: ", err);
      });
    }
  }, [props.dialogStatus]);

  useEffect(() => {
    if (selectedStates.length > 0) {
      const stateNames = selectedStates.map(s => typeof s === 'object' ? s.name : s);
      
      HttpService({
        url: getDistrictsList,
        method: 'GET',
        params: { state: stateNames },
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      }).then(resp => {
        let districts = resp?.data?.data || [];
        const formattedDistricts = districts.map(d => ({ name: d.district || d.name || d }));
        setDistrictsList(formattedDistricts);
        
        setSelectedDistricts(prev => prev.filter(d => {
          const dName = typeof d === 'object' ? d.name : d;
          return formattedDistricts.some(fd => fd.name === dName);
        }));
      }).catch(err => {
        console.error("Error fetching districts: ", err);
      });
    } else {
      setDistrictsList([]);
      setSelectedDistricts([]);
    }
  }, [selectedStates]);

  const filteredAvailableItems = availableItems.filter(item => {
    let matchGender = true;
    if (selectedGender !== 'All') {
      const g = item.gender ? item.gender.toLowerCase() : '';
      if (selectedGender === 'Male') {
        matchGender = g === 'male' || g === 'm';
      } else if (selectedGender === 'Female') {
        matchGender = g === 'female' || g === 'f';
      } else {
        matchGender = item.gender === selectedGender;
      }
    }
    let matchState = true;
    if (selectedStates.length > 0) {
      const stateNames = selectedStates.map(s => typeof s === 'object' ? s.name : s);
      matchState = stateNames.includes(item.state);
    }
    let matchDistrict = true;
    if (selectedDistricts.length > 0) {
      const districtNames = selectedDistricts.map(d => typeof d === 'object' ? d.name : d);
      matchDistrict = districtNames.includes(item.district);
    }
    
    let matchSearch = true;
    if (availableSearch && availableSearch.trim() !== '') {
      const searchLower = availableSearch.trim().toLowerCase();
      matchSearch = (item.name && item.name.toLowerCase().includes(searchLower)) || (item.contactNumber && String(item.contactNumber).toLowerCase().includes(searchLower));
    }
    return matchGender && matchState && matchDistrict && matchSearch;
  });

  const handleDayToggle = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleNext = () => {
    let isValid = true;
    if (!batchName) {
      setBatchNameError('Batch Name is required');
      isValid = false;
    } else {
      setBatchNameError('');
    }

    if (selectedProgram === 'Select Program *') {
      setSelectedProgramError('Program is required');
      isValid = false;
    } else {
      setSelectedProgramError('');
    }

    if (selectedCoordinator === 'Select Coordinator *') {
      setCoordinatorError('Coordinator is required');
      isValid = false;
    } else {
      setCoordinatorError('');
    }

    if (!startDate) {
      setStartDateError('Start Date is required');
      isValid = false;
    } else {
      setStartDateError('');
    }

    if (!endDate) {
      setEndDateError('End Date is required');
      isValid = false;
    } else {
      setEndDateError('');
    }

    if (startDate && endDate) {
      if (!dayjs(endDate).isAfter(dayjs(startDate))) {
         setEndDateError('End Date must be after Start Date');
         isValid = false;
      }
    }

    if (selectedDays.length === 0) {
      setDaysError('Please select at least one day');
      isValid = false;
    } else {
      setDaysError('');
    }

    if (isValid) {
      setStep(2); // Members selection is step 2 now
      fetchAvailableWorkers(availableSearch, selectedProgramApplicableFor);
    }
  };

  const handleAddBatch = (assessmentData) => {
    setLoader(true);
    let options = {
      url: createTrainingBatch,
      method: 'POST',
      payload: {
        batchName: batchName,
        programId: selectedProgramId,
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
        volunteerName: selectedCoordinator.split(' - ')[0],
        volunteerCN: selectedCoordinatorContact,
        members: selectedItems.map(item => item.id),
        classFrequency: selectedDays,
        // Assessment details if required
        ...(assessmentData?.isAssessmentRequired && {
          assessmentConfig: {
            easyQuestions: assessmentData.easyQuestions,
            mediumQuestions: assessmentData.mediumQuestions,
            hardQuestions: assessmentData.hardQuestions,
            qualificationPercentage: assessmentData.qualificationPercentage,
            time: assessmentData.time,
            actionOnQualification: assessmentData.actionOnQualification
          }
        })
      },
      headers: {
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      }
    };

    HttpService(options).then(resp => {
      setLoader(false);
      props.updateFunc(false, true);
    }).catch(err => {
      console.log("Error in creating training batch: ", err);
      setLoader(false);
      if (err?.status === 403) {
        localStorage.clear();
        navigate('/Login');
      }
    });
  };

  return (
    <Dialog maxWidth='md' fullWidth open={props.dialogStatus} onClose={() => props.updateFunc(false)}>
      <DialogTitle style={titleStyle}>
        Add New Batch
      </DialogTitle>
      <DialogContent>
            <Box style={{padding: '1.5rem 0rem 0rem 0rem'}}>
                {isLoader && <Loader />}
                <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '1.5rem', borderBottom: `2px solid ${lightGrey}`, width: '100%' }}>
                  <Box sx={{ display: 'flex', gap: '3rem' }}>
                    {['Batch Info', 'Members', 'Assessment'].map((label, index) => {
                      const s = index + 1;
                      const isActive = step === s;
                      const isDisabled = s === 3 && step < 3; // Keep the restriction for Add mode
                      return (
                        <Typography
                          key={s}
                          onClick={() => {
                            if (!isDisabled) setStep(s);
                          }}
                          sx={{
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            padding: '0.2rem 0.5rem 0.5rem 0.5rem',
                            fontSize: '0.9rem',
                            fontWeight: isActive ? 600 : 500,
                            color: isActive ? headingBlue : (isDisabled ? mediumGrey : 'gray'),
                            borderBottom: isActive ? `2px solid ${headingBlue}` : '2px solid transparent',
                            marginBottom: '-2px',
                            transition: 'all 0.2s',
                            '&:hover': { color: isDisabled ? mediumGrey : headingBlue }
                          }}
                        >
                          {label}
                        </Typography>
                      );
                    })}
                  </Box>
                </Box>
                {step === 1 && (
                    <Box sx={{ width: '70%', margin: '0 auto' }}>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <CustomTextField placeHolder='Batch Name *' value={batchName} setFunc={setBatchName} width="15rem" />
                                <Typography style={errorTextStyle}>{batchNameError}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', '& input': { fontSize: '0.9rem' }, '& .MuiInputBase-input::placeholder': { color: '#a9a9a9', opacity: '1 !important' }, '& .MuiInputLabel-root': { color: '#a9a9a9', fontSize: '0.9rem' } }}>
                                {/* <Typography style={{ color: headingBlue, fontSize: '0.9rem', paddingBottom: '0.2rem' }}>Start Date *</Typography> */}
                                <CustomDatePicker width='16rem' selectedDate={startDate} setSelectedDate={setStartDate} minDateValue={dayjs()} isNotRestricted={true} placeHolder="Start Date *" />
                                <Typography style={errorTextStyle}>{startDateError}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', '& input': { fontSize: '0.9rem' }, '& .MuiInputBase-input::placeholder': { color: '#a9a9a9', opacity: '1 !important' }, '& .MuiInputLabel-root': { color: '#a9a9a9', fontSize: '0.9rem' } }}>
                                {/* <Typography style={{ color: headingBlue, fontSize: '0.9rem', paddingBottom: '0.2rem' }}>End Date *</Typography> */}
                                <CustomDatePicker width='16rem' selectedDate={endDate} setSelectedDate={setEndDate} minDateValue={startDate ? dayjs(startDate) : dayjs()} isNotRestricted={true} placeHolder="End Date *" />
                                <Typography style={errorTextStyle}>{endDateError}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={7} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
                                <CustomDropDown placeHolder='Select Program *' list={programsList} value={selectedProgram} setFunc={(val) => { setSelectedProgram(val.name); setSelectedProgramId(val.value); setSelectedProgramApplicableFor(val.applicableFor); setSelectedCoordinator('Select Coordinator *'); setSelectedCoordinatorContact(''); fetchCoordinators(val.value); }} isValueRequired={true} width="100%" />
                                <Typography style={errorTextStyle}>{selectedProgramError}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={5} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
                                <CustomDropDown placeHolder='Select Coordinator *' list={coordinatorList} value={selectedCoordinator} setFunc={(val) => { setSelectedCoordinator(val.name); setSelectedCoordinatorContact(val.value); }} isValueRequired={true} width="100%" />
                                <Typography style={errorTextStyle}>{coordinatorError}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.5rem' }}>
                                <Typography style={{ color: headingBlue, fontSize: '0.9rem', width: '100%', textAlign: 'left', paddingBottom: '0.3rem' }}>Class Schedule *</Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', gap: '0.2rem' }}>
                                    {daysOfWeek.map((day) => (
                                        <Box key={day} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '15%', maxWidth: '4rem' }}>
                                            <Checkbox
                                                checked={selectedDays.includes(day)}
                                                onChange={() => handleDayToggle(day)}
                                                size="small"
                                                sx={{ padding: '0.1rem', color: headingBlue }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontSize: '0.75rem',
                                                    color: headingBlue,
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    width: '100%',
                                                    textAlign: 'center'
                                                }}
                                                title={day}
                                            >
                                                {day}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                                <Typography style={errorTextStyle}>{daysError}</Typography>
                            </Grid>
                        </Grid>
                        <Box style={{padding: '1rem 0rem 0rem 0rem', display: 'flex', justifyContent: 'center'}}>
                            <Button style={{...buttonStyle, padding: '0.2rem 0.4rem', backgroundColor: red}}
                              onClick={() => props.updateFunc(false)}
                            >Cancel</Button>
                            <Button style={{...buttonStyle, padding: '0.2rem 0.4rem', marginLeft: '0.5rem'}}
                              onClick={handleNext}
                            >Next</Button>
                        </Box>
                    </Box>)}
                {step === 2 && (
                    <>
                        <Grid container spacing={2} alignItems="center" justifyContent="center">
                            <Grid item xs = {6} sm = {6}>
                                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem'}}>
                                    <Typography style={{color: headingBlue, textAlign: 'left', fontWeight: 'bold', fontSize: '1rem'}}>Eligible Members</Typography>
                                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                                        <CustomTextField placeHolder="Search..." value={availableSearch} setFunc={updateSearch} width="14rem" />
                                        <IconButton onClick={(e) => setFilterAnchorEl(e.currentTarget)} size="small" style={{marginLeft: '0.5rem', padding: '2px'}}>
                                            <FilterListIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>
                                <Paper sx={{height: '15rem', overflowY: 'auto', overflowX: 'hidden', border: `1px solid ${mediumGrey}`, "&::-webkit-scrollbar": { display: "none" }, scrollbarWidth: "none"}}>
                                    <Box style={{display: 'flex', padding: '0.5rem', borderBottom: `1px solid ${mediumGrey}`, fontSize: '0.8rem', color: 'black'}}>
                                        <Box sx={{ flex: '0 0 30%', paddingRight: '0.5rem' }}>Name</Box>
                                        <Box sx={{ flex: '0 0 25%', paddingRight: '0.5rem' }}>Contact</Box>
                                        <Box sx={{ flex: '0 0 15%', paddingRight: '0.5rem', textAlign: 'center' }}>Gender</Box>
                                        <Box sx={{ flex: '0 0 30%' }}>District <br></br> State</Box>
                                    </Box>
                                    {filteredAvailableItems.map((item, idx) => (
                                        <Box 
                                            key={item.id} 
                                            onClick={() => {
                                                setActiveLeftItems(prev => 
                                                    prev.find(i => i.id === item.id) 
                                                        ? prev.filter(i => i.id !== item.id) 
                                                        : [...prev, item]
                                                );
                                            }}
                                            sx={{
                                                display: 'flex',
                                                padding: '0.5rem', 
                                                cursor: 'pointer', 
                                                backgroundColor: activeLeftItems.find(i => i.id === item.id) ? '#e0e0e0' : 'transparent',
                                                borderBottom: `1px solid #f0f0f0`,
                                                fontSize: '0.85rem',
                                                transition: 'background-color 0.2s ease',
                                                '&:hover': {
                                                    backgroundColor: activeLeftItems.find(i => i.id === item.id) ? '#e0e0e0' : '#f9f9f9'
                                                }
                                            }}
                                        >
                                            <Box sx={{ flex: '0 0 30%', paddingRight: '0.5rem', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.name}
                                            </Box>
                                            <Box sx={{ flex: '0 0 25%', paddingRight: '0.5rem', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.contactNumber}
                                            </Box>
                                            <Box sx={{ flex: '0 0 15%', paddingRight: '0.5rem', textAlign: 'center' }}>
                                                {item.gender === 'Male' ? 'M' : item.gender === 'Female' ? 'F' : (item.gender || '-')}
                                            </Box>
                                            <Box sx={{ flex: '0 0 30%', overflow: 'hidden' }} title={`${item.district || '-'}, ${item.state || '-'}`}>
                                                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.district || '-'}</Box>
                                                <Box sx={{ fontSize: '0.7rem', color: 'gray', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.chapter || '-'}</Box>
                                            </Box>
                                        </Box>
                                    ))}
                                    {filteredAvailableItems.length === 0 && (
                                        <Typography style={{padding: '1rem', textAlign: 'center', color: 'gray', fontSize: '0.85rem'}}>No eligible members found.</Typography>
                                    )}
                                </Paper>
                            </Grid>
                            
                            <Grid item style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', paddingLeft: '1rem', paddingRight: '1rem'}}>
                                <Button 
                                    variant="contained" 
                                    style={{backgroundColor: headingBlue, color: 'white', minWidth: '0', padding: '0.2rem 0.5rem'}}
                                    onClick={() => {
                                        if(activeLeftItems.length > 0) {
                                            setSelectedItems(prev => [...prev, ...activeLeftItems]);
                                            setAvailableItems(prev => prev.filter(i => !activeLeftItems.find(ali => ali.id === i.id)));
                                            setActiveLeftItems([]);
                                        }
                                    }}
                                >
                                    &gt;
                                </Button>
                                <Button 
                                    variant="contained" 
                                    style={{backgroundColor: headingBlue, color: 'white', minWidth: '0', padding: '0.2rem 0.5rem'}}
                                    onClick={() => {
                                        if(activeRightItems.length > 0) {
                                            setAvailableItems(prev => [...prev, ...activeRightItems]);
                                            setSelectedItems(prev => prev.filter(i => !activeRightItems.find(ari => ari.id === i.id)));
                                            setActiveRightItems([]);
                                        }
                                    }}
                                >
                                    &lt;
                                </Button>
                            </Grid>

                            <Grid item xs>
                                <Typography style={{color: headingBlue, marginBottom: '1rem', textAlign: 'left', fontWeight: 'bold', fontSize: '1rem'}}>Selected Members</Typography>
                                <Paper sx={{height: '15rem', overflowY: 'auto', overflowX: 'hidden', border: `1px solid ${mediumGrey}`, "&::-webkit-scrollbar": { display: "none" }, scrollbarWidth: "none"}}>
                                    <Box style={{display: 'flex', padding: '0.5rem', borderBottom: `1px solid ${mediumGrey}`, fontSize: '0.8rem', color: 'black'}}>
                                        <Box sx={{ flex: '0 0 30%', paddingRight: '0.5rem' }}>Name</Box>
                                        <Box sx={{ flex: '0 0 25%', paddingRight: '0.5rem' }}>Contact</Box>
                                        <Box sx={{ flex: '0 0 15%', paddingRight: '0.5rem', textAlign: 'center' }}>Gender</Box>
                                        <Box sx={{ flex: '0 0 30%' }}>Location</Box>
                                    </Box>
                                    {selectedItems.map((item, idx) => (
                                        <Box 
                                            key={item.id} 
                                            onClick={() => {
                                                setActiveRightItems(prev => 
                                                    prev.find(i => i.id === item.id) 
                                                        ? prev.filter(i => i.id !== item.id) 
                                                        : [...prev, item]
                                                );
                                            }}
                                            sx={{
                                                display: 'flex',
                                                padding: '0.5rem', 
                                                cursor: 'pointer', 
                                                backgroundColor: activeRightItems.find(i => i.id === item.id) ? '#e0e0e0' : 'transparent',
                                                borderBottom: `1px solid #f0f0f0`,
                                                fontSize: '0.85rem',
                                                transition: 'background-color 0.2s ease',
                                                '&:hover': {
                                                    backgroundColor: activeRightItems.find(i => i.id === item.id) ? '#e0e0e0' : '#f9f9f9'
                                                }
                                            }}
                                        >
                                            <Box sx={{ flex: '0 0 30%', paddingRight: '0.5rem', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.name}
                                            </Box>
                                            <Box sx={{ flex: '0 0 25%', paddingRight: '0.5rem', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.contactNumber}
                                            </Box>
                                            <Box sx={{ flex: '0 0 15%', paddingRight: '0.5rem', textAlign: 'center' }}>
                                                {item.gender === 'Male' ? 'M' : item.gender === 'Female' ? 'F' : (item.gender || '-')}
                                            </Box>
                                            <Box sx={{ flex: '0 0 30%', overflow: 'hidden' }} title={`${item.district || '-'}, ${item.state || '-'}`}>
                                                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.district || '-'}</Box>
                                                <Box sx={{ fontSize: '0.7rem', color: 'gray', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.state || '-'}</Box>
                                            </Box>
                                        </Box>
                                    ))}
                                    {selectedItems.length === 0 && (
                                        <Typography style={{padding: '1rem', textAlign: 'center', color: 'gray', fontSize: '0.85rem'}}>No members selected.</Typography>
                                    )}
                                </Paper>
                            </Grid>
                        </Grid>

                        <Box style={{padding: '1rem 0rem 0rem 0rem', display: 'flex', justifyContent: 'center'}}>
                            <Button style={{...buttonStyle, padding: '0.2rem 0.4rem', backgroundColor: red}}
                              onClick={() => setStep(1)}
                            >Back</Button> {/* Back to step 1 */}
                            <Button style={{...buttonStyle, padding: '0.2rem 0.4rem', marginLeft: '0.5rem'}}
                              onClick={() => setStep(3)}
                            >Next</Button> {/* Next to step 3 */}
                        </Box>

                        <Popover
                            open={Boolean(filterAnchorEl)}
                            anchorEl={filterAnchorEl}
                            onClose={() => setFilterAnchorEl(null)}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        >
                            <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: '1rem', width: '16rem' }}>
                                <Typography variant="subtitle2" style={{color: headingBlue, fontWeight: 'bold'}}>Filters</Typography>
                                <CustomDropDown
                                    placeHolder="Gender"
                                    list={[{name: 'All', value: 'All'}, {name: 'Male', value: 'Male'}, {name: 'Female', value: 'Female'}]}
                                    value={selectedGender}
                                    setFunc={(val) => {
                                      setSelectedGender(val)
                                    }}
                                    width="100%" 
                                    MenuProps={{ PaperProps: { style: { maxWidth: '14rem' } } }}
                                />
                                <MultiSelectDropDown
                                    placeHolder="States"
                                    list={statesList}
                                    value={selectedStates}
                                    setFunc={setSelectedStates}

                                    // width="100%"
                                    // MenuProps={{ PaperProps: { style: { maxWidth: '14rem' } } }}
                                />
                                <MultiSelectDropDown
                                    placeHolder="Districts"
                                    list={districtsList}
                                    value={selectedDistricts}
                                    setFunc={setSelectedDistricts}
                                    width="100%"
                                    MenuProps={{ PaperProps: { style: { maxWidth: '14rem' } } }}
                                />
                                <Box style={{display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem'}}>
                                    <Button onClick={() => { setSelectedGender('All'); setSelectedStates([]); setSelectedDistricts([]); }} size="small" style={{...buttonStyle, backgroundColor: 'white', color: headingBlue, border: `1px solid ${headingBlue}`, marginRight: '0.5rem'}}>Clear</Button>
                                    <Button onClick={() => setFilterAnchorEl(null)} size="small" style={buttonStyle}>Apply</Button>
                                </Box>
                            </Box>
                        </Popover>
                    </>
                )}
                {step === 3 && (
                    <AssessmentConfiguration onBack={() => setStep(2)} onSubmit={handleAddBatch} />
                )}
            </Box>
        </DialogContent>
    </Dialog>
  );
};

export default AddBatchDialog;
